
export default function FeaturesSection() {
  const features = [
    {
      icon: "ri-shield-check-line",
      title: "Superior Protection",
      description: "Advanced engineering provides maximum protection against weather, corrosion, and environmental threats for long-term aircraft safety."
    },
    {
      icon: "ri-tools-line",
      title: "Easy Installation",
      description: "Modular design and precision manufacturing ensure quick, efficient installation with minimal site preparation requirements."
    },
    {
      icon: "ri-time-line",
      title: "Long-Term Durability",
      description: "High-quality materials and protective coatings deliver decades of reliable service with minimal maintenance requirements."
    },
    {
      icon: "ri-settings-3-line",
      title: "Custom Engineering",
      description: "Tailored solutions designed to meet specific operational requirements and site conditions for optimal performance."
    },
    {
      icon: "ri-award-line",
      title: "Military Grade Quality",
      description: "Meets stringent military specifications and industry standards for the most demanding aviation applications."
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Expert Support",
      description: "Comprehensive technical support from design consultation through installation and ongoing maintenance services."
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Our <strong>Arch Panel Systems</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Engineered excellence meets proven performance in every arch panel system we manufacture.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
